import React, { Component } from 'react';
import Select from 'react-dropdown-select';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getCSAProductList, sendCsaProductSearchValue } from "../../actions/csaApp";
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { addToCart } from '../../actions/cart'



class ProductAll extends Component{
    constructor(){
        super()
     
    }
    render(){
          const productCode = localStorage.getItem('csa_product_code');
        const skuCode = localStorage.getItem('csa_sku_id');
        const color_id = localStorage.getItem('selectedColor');
        const size_id = localStorage.getItem('selectedSize')
        const { connection_id, getCSAProductList, sendCsaProductSearchValue } = this.props;
       
        let options = {
            "connection_id": connection_id,
            "product_id": productCode,
            "sku_id":skuCode,
            "barcode":null,
            "store_flag":'AL',
            "size_id":  [size_id],
            "color_id":  [color_id]
            }
            getCSAProductList(options)
            sendCsaProductSearchValue(options)
    this.props.history.push('/csa-products')
       
        

        return(
            <React.Fragment>
                      
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    csaVariants: state.csa.csaVariants,
    connection_id: state.tenant.connection_id,
    csaProducts: state.csa.csaProducts,
    loading: state.csa.loading,
    csaSearchValue: state.csa.csaSearchValue,
    Order_type: state.tenant.Order_type,
    store_details: state.tenant.store_details,
    web_session_trans_id: state.user.user_details && state.user.web_session_trans_id,

    consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
    

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getCSAProductList, sendCsaProductSearchValue,addToCart },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProductAll));
